module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-16x16-fce419440f286a4d7c059e234759229e.png";